/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Trigger/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import Empty from './Empty/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Trigger({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/TreatmentSelect/Content/Content/Trigger",
  disabled
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let selectedValueData = fromData.useDataFormat({ viewPath,
context: 'selected',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: selectedValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
 disabled={disabled}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Empty'}>
<Empty
  viewPath={`${viewPath}/Empty`}
 disabled={disabled}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}